import { render, staticRenderFns } from "./SearchCR.vue?vue&type=template&id=627225ec&"
import script from "./SearchCR.vue?vue&type=script&lang=js&"
export * from "./SearchCR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports